import i18n from "../i18n";
import { apiBaseUrl } from "./auth";
import { getStoredLanguage } from "../context/I18nContext";

const TEACHERS_BASE = `${apiBaseUrl}/api/auth/teachers`;

async function request(path = "/", { params } = {}) {
  const headers = {
    Accept: "application/json",
    "Accept-Language": getStoredLanguage(),
  };

  const queryParams = params
    ? { ...params, lang: getStoredLanguage() }
    : { lang: getStoredLanguage() };
  const queryString = `?${new URLSearchParams(queryParams).toString()}`;

  const response = await fetch(`${TEACHERS_BASE}${path}${queryString}`, {
    method: "GET",
    headers,
  });

  const isJson = response.headers
    .get("content-type")
    ?.includes("application/json");
  const payload = isJson ? await response.json() : {};

  if (!response.ok) {
    const message = payload.error || i18n.t("errors.operationFailed");
    const error = new Error(message);
    error.status = response.status;
    throw error;
  }

  return payload;
}

export function fetchPublicTeachers({ page } = {}) {
  const params = page ? { page } : undefined;
  return request("/public/", { params });
}

export function fetchPublicTeacher({ teacherId }) {
  if (!teacherId) {
    const error = new Error(i18n.t("errors.operationFailed"));
    error.status = 400;
    throw error;
  }
  return request(`/${teacherId}/public/`);
}
